<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editDepartments') }}</h1>
      <div class="form-container">
        <DepartmentForm :data="relations.instance" @save="save"></DepartmentForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {mapState} from 'vuex'
  import DepartmentForm from "../../components/DepartmentForm";

  export default {
    components: {
      DepartmentForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/update', {actionType: 'departments', payload}).then(() =>
          this.$router.push({ name: 'manageDepartments'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'departments', id: this.$route.params.id})
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      breadcrumbs() {
        return [
          {name: 'manageDepartments', path: 'manageDepartments'},
          {name: 'editDepartments'}
        ]
      }
    }
  }
</script>